<article class="position-sticky px-2 px-lg-3" *ngIf="showBanner">
   <div class="d-flex gap-lg-4 gap-2 align-items-center justify-content-center py-2">
      <p class="mb-0 text-start">All Yearly Plans, <span class="fw-600">Now 50% OFF</span>!!</p>
      <div 
         class="timer-wrapper d-none d-lg-grid bg-black px-3 gap-3 pb-1 pt-2"
         *ngIf="countdown$ | async as countdown"
      >
         <div class="d-grid text-center">
            <span class="time-span fw-500 lh-1">{{ countdown.days | number: '2.0-0' }}</span>
            <span class="text-span text-white lh-base">DAY</span>
         </div>
         <div class="d-grid text-center">
            <span class="time-span fw-500 lh-1">{{ countdown.hours | number: '2.0-0' }}</span>
            <span class="text-span text-white lh-base">HOUR</span>
         </div>
         <div class="d-grid text-center">
            <span class="time-span fw-500 lh-1">{{ countdown.minutes | number: '2.0-0' }}</span>
            <span class="text-span text-white lh-base">MIN</span>
         </div>
         <div class="d-grid text-center">
            <span class="time-span fw-500 lh-1">{{ countdown.seconds | number: '2.0-0' }}</span>
            <span class="text-span text-white lh-base">SEC</span>
         </div>
      </div>
      <a routerLink="/pricing" class="border-0 text-nowrap d-flex align-items-center gap-1">
         CLAIM NOW
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.5 12H5m8 6s6-4.419 6-6-6-6-6-6"/>
         </svg>
      </a>
   </div>
   <!-- <button (click)="hideBanner()" class="position-absolute border-0 end-0 bg-transparent p-2">
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="m.71.707 18 18m-18 0 18-18" stroke="#798196" stroke-width="2"/>
      </svg>
   </button> -->
</article>


<!-- <article class="position-relative px-3" *ngIf="showTradingBanner">
   <div class="d-flex gap-lg-4 gap-2 align-items-center justify-content-center py-2 pe-4 pe-lg-0">
      <p class="mb-0 fw-500 text-start">Musaffa's Global <span class="fw-600">Halal</span> Trading Platform is Here!</p>
      <a href="https://trade.musaffa.com/" target="_blank" rel="noopener noreferrer" class="border-0 text-nowrap d-block">
         Start Investing Now
      </a>
   </div>
   <button (click)="hideBanner()" class="position-absolute border-0 end-0 bg-transparent p-2">
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="m.71.707 18 18m-18 0 18-18" stroke="#798196" stroke-width="2"/>
      </svg>
   </button>
</article> -->